/* eslint-disable react-hooks/rules-of-hooks */
import { useEffect, useState } from 'react'
import { BulletList } from 'react-content-loader'

import '../../ShopList/list.scss'

import { useNavigate } from 'react-router-dom'
import moment from 'jalali-moment'

export default function index(data) {
  const [category, setCategory] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    setCategory(data.data)
  }, [data])

  return (
    <>
      <table className='table'>
        <thead>
          <tr>
            <th>عنوان پیام</th>
            <th>شماره موبایل پیک</th>
            <th>نام پیک</th>
            <th>تاریخ ارسال</th>
            <th>عملیات</th>
          </tr>
        </thead>
        <tbody>
          {category ? category.map(item => (
              <tr key={item._id}>
                <td>{item.title}</td>
                <td>0{item.peyk[0].phoneNumber}</td>
                <td>{item.peyk[0].name}</td>
                <td>{moment(item.createdAt).locale('fa').format('YYYY/MM/DD HH:mm')}</td>
                <td>
                  <button onClick={() => navigate(`/peyk/messages/detail/${item._id}`)}>مشاهده</button>
                </td>
              </tr>
            )) : <tr><td colSpan="5"><BulletList rtl style={{ width: '30%', rowspan: '5' }}/></td></tr>}
        </tbody>
      </table>
    </>
  );
}
